import { treeHref } from './prettyArchiveLinks';

/**
 * Query flag consumed by `TreeViewEnhanced` to open the shared add-person dialog
 * with **no** `addPersonLinkContext` (standalone creation — never inherits relationship UI).
 * For future flows (invite, DNA, suggestions), add new query keys and handle them alongside
 * this one on the tree page so contextual CTAs stay consistent.
 */
export const TREE_OPEN_ADD_PERSON_QUERY = 'openAddPerson';

/**
 * List view + neutral add-person modal (same experience as the People toolbar).
 * @param {string | { id: string, slug?: string }} treeOrId - Tree id or object with optional slug for pretty URLs.
 */
export function buildTreePeopleAddPersonUrl(treeOrId) {
  const id = typeof treeOrId === 'string' ? treeOrId : treeOrId?.id;
  if (!id) return '/dashboard';
  const base = typeof treeOrId === 'string' ? treeHref({ id }) : treeHref(treeOrId || { id });
  return `${base}?tab=grid&${TREE_OPEN_ADD_PERSON_QUERY}=1`;
}

/** Remember which tree the user last opened (dashboard readiness link, etc.). */
export const LAST_OPENED_TREE_KEY = 'gb_last_opened_tree_id';

export function setLastOpenedTreeId(treeId) {
  if (!treeId || typeof window === 'undefined') return;
  try {
    localStorage.setItem(LAST_OPENED_TREE_KEY, String(treeId));
  } catch {
    /* ignore */
  }
}

export function getLastOpenedTreeId() {
  if (typeof window === 'undefined') return null;
  try {
    const v = localStorage.getItem(LAST_OPENED_TREE_KEY);
    return v && String(v).trim() ? String(v).trim() : null;
  } catch {
    return null;
  }
}

export function pickReadinessTree(trees = []) {
  if (!trees.length) return null;
  const lastId = getLastOpenedTreeId();
  if (lastId) {
    const match = trees.find((t) => t.id === lastId);
    if (match) return match;
  }
  return trees[0];
}
